import _ from 'lodash';

/** PerformanceCheckConstants.ASSRNC_TY_SE_CODE_EX — 재점검 보증만 */
export const ASSURANCE_EX_RECHECK_WARRANTY = '4';

/** 재점검 계열(보증/비보증 무관) — 상품화 비표시 등 */
export const RECHECK_ASSURANCE_EX_CODES = ['4', '5', '6'];

/**
 * 서버/JSON에서 코드가 숫자로 올 수 있어 문자열로 정규화.
 * 결제 JSON에 없을 때 점검 본문(checkData)에 동일 필드가 있는 경우도 대비.
 */
export function getAssuranceTypeEx(payment, checkData) {
  const raw =
    _.get(payment, 'ASSRNC_TY_SE_CODE_EX') ??
    _.get(payment, 'assuranceTypeEx') ??
    _.get(checkData, 'ASSRNC_TY_SE_CODE_EX') ??
    _.get(checkData, 'assuranceTypeEx');
  if (raw === undefined || raw === null || raw === '') return '';
  return String(raw).trim();
}

export function isAssuranceExRecheckWarranty(payment, checkData) {
  return getAssuranceTypeEx(payment, checkData) === ASSURANCE_EX_RECHECK_WARRANTY;
}

/** 확장코드 기준 재점검 여부 Y/N (4·5·6) */
export function getRecheckYNFromAssuranceEx(exNorm) {
  const v = String(exNorm || '').trim();
  return RECHECK_ASSURANCE_EX_CODES.includes(v) ? 'Y' : 'N';
}

/**
 * 보증 Y / 비보증 N (확장 미선택·알 수 없음 → null)
 * 3·4·7 보증, 5·6 비보증
 */
export function getHWarrantyFromAssuranceEx(exNorm) {
  const v = String(exNorm || '').trim();
  if (['3', '4', '7'].includes(v)) return 'Y';
  if (['5', '6'].includes(v)) return 'N';
  return null;
}

/**
 * 기존 API hRecheck와 동기: 보증(N)·비보증(Y) ↔ hWarranty 반대
 */
export function getHRecheckFromHWarranty(hWarranty) {
  if (hWarranty === 'Y') return 'N';
  if (hWarranty === 'N') return 'Y';
  return null;
}

/**
 * 점검료구분 필터 카테고리
 * - generalWarranty: 일반보증
 * - recheck: 재점검
 * - recheckWarranty: 재점검보증
 */
export const CHECK_PRICE_FILTER_CATEGORY = {
  GENERAL_WARRANTY: 'generalWarranty',
  RECHECK: 'recheck',
  RECHECK_WARRANTY: 'recheckWarranty',
};

export function getCheckPriceFilterCategoryFromEx(exNorm) {
  const v = String(exNorm || '').trim();
  if (v === '4') return CHECK_PRICE_FILTER_CATEGORY.RECHECK_WARRANTY;
  if (v === '5' || v === '6') return CHECK_PRICE_FILTER_CATEGORY.RECHECK;
  if (['3', '7'].includes(v))
    return CHECK_PRICE_FILTER_CATEGORY.GENERAL_WARRANTY;
  return null;
}

/**
 * 레거시 hRecheck fallback:
 * - Y(비보증) -> 재점검 카테고리
 * - N(보증) -> 일반보증 카테고리
 */
export function getCheckPriceFilterCategoryFromHRecheck(hRecheck) {
  if (hRecheck === 'Y') return CHECK_PRICE_FILTER_CATEGORY.RECHECK;
  if (hRecheck === 'N')
    return CHECK_PRICE_FILTER_CATEGORY.GENERAL_WARRANTY;
  return null;
}

/**
 * 상품화 숨김: recheck 저장값 Y 이거나, 미전달 시 확장코드 4·5·6
 */
export function shouldHideProductization(recheckProp, payment, checkData) {
  if (recheckProp === 'Y') return true;
  if (recheckProp === 'N') return false;
  const ex = getAssuranceTypeEx(payment, checkData);
  return RECHECK_ASSURANCE_EX_CODES.includes(ex);
}
